import { SkaldElement, useSkaldSubelements } from "@skaldaura/devkit"
import { useState } from "react"
import Popup from "reactjs-popup"
import "./scrollSection.scss"


interface IProps {
    element: SkaldElement
}

export default function ScrollChildren(props: IProps) {
    const [subelements] = useSkaldSubelements(props.element)
    const [open, setOpen] = useState<boolean>(false)

    const firstContent = <img src={props.element.value} className="scroll-section-content" />
    
    const closeModal = () => setOpen(false)
    const openModal = () => setOpen(true)
    
    return (
        <>
            {subelements.length > 0 ?
                <Popup
                    trigger={firstContent}
                    modal
                    open={open}
                    onOpen={openModal}
                    onClose={closeModal}
                    closeOnDocumentClick
                >
                    <img src={subelements[0].value} className="scroll-section-children" onClick={closeModal}/>
                </Popup>
                :
                firstContent
            }
        </>
    )
}